// import About from "../pages/public/AboutUs/AboutUs";
// import AccuRateSustainability from "./../pages/public/AccurateSustainability/AccuRateSustainability";
// import ContactUs from "../pages/public/ContactUs/ContactUs";

import DashboardHome from "../pages/Dashboard/DashboardHome";
import SingleUsers from "../pages/Users/SingleUsers";
import Schedule from "../pages/Schedule/Schedule";
import Course from "../pages/Course/Course";
import Students from "../pages/Users/Students";
import CourseSingle from "../pages/Course/CourseSingle";
import LiveClass from "../pages/LiveClass/LiveClass";
import RoleList from "../pages/Role/RoleList";
import Employee from "../pages/Employee/Employee";
import Transactions from "../pages/Transactions/Transactions";
import AddCourse from "../pages/Course/AddCourse";
import Category from "../pages/Category/Category";
import PremiumStudent from "../pages/Users/PremiumStudent";
import Blog from "../pages/Blog/Blog";
import Ticket from "../pages/Ticket/Ticket";
import NewsLetter from "../pages/NewsLetter/NewsLetter";

export const routes = [
  // {
  //   notLazy: true,
  //   path: "/",
  //   element: Home,
  //   role: "public",
  //   name: "Home",
  //   subRouting: false,
  // },
  {
    notLazy: true,
    path: "/dashboard",
    element: DashboardHome,
    role: "private",
    name: "Home",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/role",
    element: RoleList,
    role: "private",
    name: "RoleList",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/category",
    element: Category,
    role: "private",
    name: "Category",
    subRouting: false,
  },

  {
    notLazy: true,
    path: "/employee-management",
    element: Employee,
    role: "private",
    name: "Employee",
    subRouting: false,
  },

  {
    notLazy: true,
    path: "/course",
    element: Course,
    role: "private",
    name: "Owner Users",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/blog",
    element: Blog,
    role: "private",
    name: "Blog",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/tickets",
    element: Ticket,
    role: "private",
    name: "Ticket",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/newsletter",
    element: NewsLetter,
    role: "private",
    name: "NewsLetter",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/add-course",
    element: AddCourse,
    role: "private",
    name: "Owner Users",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/course/:name",
    element: CourseSingle,
    role: "private",
    name: "CourseSingle",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/students",
    element: Students,
    role: "private",
    name: "Students",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/premium-student",
    element: PremiumStudent,
    role: "private",
    name: "Students",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/ownerUsers/:id",
    element: SingleUsers,
    role: "private",
    name: "Single Users",
    subRouting: false,
  },

  {
    notLazy: true,
    path: "/transactions",
    element: Transactions,
    role: "private",
    name: "Transactions",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/schedule",
    element: Schedule,
    role: "private",
    name: "Schedule",
    subRouting: false,
  },
  {
    notLazy: true,
    path: "/live-class",
    element: LiveClass,
    role: "private",
    name: "LiveClass",
    subRouting: false,
  },

  // {
  //   notLazy: true,
  //   path: "/forgot-password",
  //   element: ForgotPassword,
  //   role: "private",
  //   name: "LiveClass",
  //   subRouting: false,
  // },

  // {
  //   notLazy: true,
  //   path: "/steps",
  //   element: CommonSteps,
  //   role: "withoutHeader",
  //   name: "steps",
  //   subRouting: false,
  // },

  //   {
  //     notLazy: true,
  //     path: "/templates/custom-template",
  //     element: "",
  //     role: "private",
  //     name: "Custom Template",
  //     subRouting: true,
  //     subRoute: [
  //       {
  //         notLazy: true,
  //         path: "core-customers",
  //         element: "",
  //         role: "private",
  //         name: "Custom Template",
  //       },
  //     ],
  //   },
];
